import React from 'react'
import { Link } from 'react-router-dom'

import Spinner from 'components/common/Spinner'
import Text from 'components/common/Text'
import Icon from 'components/Icon'
import useAuth from 'hooks/use-auth'
import useClientResource from 'hooks/use-client-resource'
import theme from 'theme'
import { pluralize } from 'utils/strings'

function getWelcomeMessage(first_name?: string): string {
  return `Welcome back${first_name ? `, ${first_name}` : ''}!`
}

const ProfileSection: React.FC = () => {
  const { session } = useAuth()

  const { infraIsLoading, alfiIsLoading, activeClients } = useClientResource()

  const isLoading = infraIsLoading || alfiIsLoading

  return (
    <div
      css={{
        display: 'grid',
        alignItems: 'center',
        gap: theme.space[2]
      }}
      data-testid="dashboard-profile-header"
    >
      <div
        css={{
          alignItems: 'center',
          display: 'grid'
        }}
      >
        <div
          css={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            alignItems: 'center',
            gap: theme.space[3]
          }}
        >
          <div data-testid="dashboard-profile-header-clients">
            {isLoading ? (
              <Spinner css={{ margin: 0 }} size="1em" />
            ) : (
              <Text
                as={Link}
                css={{
                  color: theme.colors.steel[1],
                  display: 'inline-grid',
                  fontSize: theme.fontSizes[1],
                  gridTemplateColumns: 'max-content min-content',
                  gap: theme.space[1],
                  alignItems: 'center',

                  '&:hover svg': {
                    transform: `translateX(${theme.space[1]}px)`
                  }
                }}
                to="/clients"
              >
                <span>
                  {activeClients.length} active{' '}
                  {pluralize('Agent', activeClients.length)}
                </span>
                <Icon
                  css={{
                    transition: 'transform 125ms linear'
                  }}
                  icon="chevronRight"
                />
              </Text>
            )}
          </div>
        </div>
      </div>

      <Text
        as="h2"
        color="medium"
        css={{
          visibility: isLoading ? 'hidden' : 'visible'
        }}
        data-testid="dashboard-profile-header-welcome"
      >
        {getWelcomeMessage(session.first_name)}
      </Text>
    </div>
  )
}

export default ProfileSection
